// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* line 16, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel {
  background-color: #f8f8f8;
  position: relative;
}
/* line 20, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel:empty {
  display: none;
}
/* line 24, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel label,
.bpp-properties-panel input {
  vertical-align: middle;
}
/* line 30, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel input,
.bpp-properties-panel button,
.bpp-properties-panel textarea {
  padding: 3px 6px;
  border: 1px solid #ccc;
}
/* line 36, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel input:focus,
.bpp-properties-panel button:focus,
.bpp-properties-panel textarea:focus {
  outline: none;
  border-color: #52B415;
  box-shadow: 0 0 1px 2px rgba(82, 180, 21, 0.2);
}
/* line 40, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel input.invalid,
.bpp-properties-panel button.invalid,
.bpp-properties-panel textarea.invalid {
  border-color: #cc3333;
  background: #f0c2c2;
}
/* line 42, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel input.invalid:focus,
.bpp-properties-panel button.invalid:focus,
.bpp-properties-panel textarea.invalid:focus {
  box-shadow: 0 0 1px 2px rgba(204, 51, 51, 0.2);
}
/* line 49, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel [type=text],
.bpp-properties-panel textarea,
.bpp-properties-panel select {
  width: 100%;
}
/* line 55, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel textarea {
  resize: vertical;
}
/* line 59, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel label {
  font-weight: bolder;
  display: inline-block;
  vertical-align: middle;
  color: #666;
}
/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel label[for] {
  cursor: pointer;
}
/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel label.bpp-hidden {
  display: none;
}
/* line 63, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel .entry-label {
  font-weight: bolder;
  display: inline-block;
  vertical-align: middle;
  color: #666;
  font-size: 120%;
  margin-top: 5px;
  margin-bottom: 10px;
  transition: margin 0.218s linear;
  font-style: italic;
}
/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel .entry-label[for] {
  cursor: pointer;
}
/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel .entry-label.bpp-hidden {
  display: none;
}
/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel .entry-label.divider {
  border-top: 1px dotted #ccc;
  padding-top: 8px;
  margin-top: 16px;
  width: 100%;
}
/* line 79, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-panel button {
  position: absolute;
  top: 0;
  height: 23px;
  width: 24px;
  overflow: hidden;
  cursor: pointer;
  background-color: #f8f8f8;
  border: 1px solid #ccc;
}
/* line 44, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel button > span {
  display: none;
}
/* line 48, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel button:before {
  font-family: "bpmn-js-pp";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}
/* line 53, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel button.add:before {
  content: '\\E803';
}
/* line 57, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel button.clear:before {
  content: '\\E802';
}
/* line 61, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */
.bpp-properties-panel button:hover {
  color: #52B415;
}
/* line 84, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-error-message,
.bpp-error-message.bpp-entry-link {
  color: #cc3333;
}
/* line 89, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-row {
  margin-top: 10px;
  margin-bottom: 10px;
}
/* line 92, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-row:first-of-type {
  margin-top: 0;
}
/* line 95, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-row:last-of-type {
  margin-bottom: 0;
}
/* line 100, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-textfield,
.bpp-textarea {
  margin-bottom: 3px;
}
/* line 105, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-radios-group {
  list-style: none;
  padding: 0;
  margin: 0 0 9px 0;
}
/* line 110, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-radios-group .bpp-radio-wrapper {
  margin: 6px 0;
}
/* line 114, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-radios-group input,
.bpp-radios-group label {
  vertical-align: middle;
}
/* line 119, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-radios-group input {
  margin-top: 0;
  margin-left: 0;
}
/* line 127, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-radios-group input,
.bpp-checkbox input {
  margin-left: 0;
}
/* line 132, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-radios-group label:after,
.bpp-checkbox label:after {
  display: none;
}
/* line 139, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-textfield input {
  padding-right: 28px;
}
/* line 143, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-textfield .clear {
  background: transparent;
  border: none;
  top: 0;
  right: 0;
}
/* line 151, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-combo-input {
  margin-top: 7px;
}
/* line 156, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-select select {
  height: 23px;
}
/* line 159, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-select button.add {
  top: -22px;
  right: 0;
}
/* line 169, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-select button.add,
.bpp-element-list button.add,
.bpp-select button.clear,
.bpp-element-list button.clear {
  top: -23px;
  border-bottom: none;
}
/* line 176, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-select button.add,
.bpp-element-list button.add {
  right: 0px;
}
/* line 180, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-select button.clear,
.bpp-element-list button.clear {
  right: 23px;
}
/* line 185, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-entry {
  margin-bottom: 9px;
}
/* line 188, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
/* 05/10/2022 Paul.  React Client is not displaying a border for the input. */
.bpp-properties-entry .bpp-field-wrapper {
  position: relative;
}
.bpp-field-wrapper > div
{
  border: 1px solid #cccccc;
  background-color: white;
  padding: 5px;
}
/* line 191, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-entry .bpp-field-wrapper input[readonly] + .clear {
  display: none;
}
/* line 197, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-hidden {
  display: none;
}
/* line 201, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
label.bpp-hidden {
  display: none;
}
/* line 206, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-add-row > button {
  position: relative;
  margin-left: 10px;
}
/* line 212, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table {
  margin-top: 10px;
}
/* line 216, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row {
  margin-bottom: 2px;
  overflow: hidden;
}
/* line 220, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > input,
.bpp-table-row > button {
  float: left;
}
/* line 225, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > label {
  padding-left: 5px;
}
/* line 232, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > label.bpp-table-row-columns-1,
.bpp-table-row > input.bpp-table-row-columns-1 {
  width: 100%;
}
/* line 234, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > label.bpp-table-row-columns-1.bpp-table-row-removable,
.bpp-table-row > input.bpp-table-row-columns-1.bpp-table-row-removable {
  width: calc(100% - 24px);
}
/* line 239, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > label.bpp-table-row-columns-2,
.bpp-table-row > input.bpp-table-row-columns-2 {
  width: 50%;
}
/* line 241, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > label.bpp-table-row-columns-2.bpp-table-row-removable,
.bpp-table-row > input.bpp-table-row-columns-2.bpp-table-row-removable {
  width: calc(50% - 12px);
}
/* line 244, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > label.bpp-table-row-columns-2:nth-child(2),
.bpp-table-row > input.bpp-table-row-columns-2:nth-child(2) {
  border-left: none;
}
/* line 250, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-table-row > button {
  border-left: none;
  position: static;
}
/* line 256, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-properties-static {
  margin-bottom: 0;
  margin-top: 0;
  border: 1px solid #ccc;
  background-color: white;
  padding: 3px 6px;
  font: 13.3333px Arial;
  width: 100%;
}
/* line 266, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-entry-link {
  cursor: pointer;
  color: #52B415;
}
/* line 271, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */
.bpp-icon-warning:before {
  font-family: "bpmn-js-pp";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: '\\E806';
}



`, "",{"version":3,"sources":["webpack://./ModuleViews/Administration/BusinessProcesses/css/properties.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA,0EAA0E;AAC1E;EACE,aAAa;AACf;AACA,0EAA0E;AAC1E;;EAEE,sBAAsB;AACxB;AACA,0EAA0E;AAC1E;;;EAGE,gBAAgB;EAChB,sBAAsB;AACxB;AACA,0EAA0E;AAC1E;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;AACA,0EAA0E;AAC1E;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;AACA,0EAA0E;AAC1E;;;EAGE,8CAA8C;AAChD;AACA,0EAA0E;AAC1E;;;EAGE,WAAW;AACb;AACA,0EAA0E;AAC1E;EACE,gBAAgB;AAClB;AACA,0EAA0E;AAC1E;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;AACA,uEAAuE;AACvE;EACE,eAAe;AACjB;AACA,uEAAuE;AACvE;EACE,aAAa;AACf;AACA,0EAA0E;AAC1E;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;AACA,uEAAuE;AACvE;EACE,eAAe;AACjB;AACA,uEAAuE;AACvE;EACE,aAAa;AACf;AACA,0EAA0E;AAC1E;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA,uEAAuE;AACvE;EACE,aAAa;AACf;AACA,uEAAuE;AACvE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;AACA,uEAAuE;AACvE;EACE,gBAAgB;AAClB;AACA,uEAAuE;AACvE;EACE,gBAAgB;AAClB;AACA,uEAAuE;AACvE;EACE,cAAc;AAChB;AACA,0EAA0E;AAC1E;;EAEE,cAAc;AAChB;AACA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA,0EAA0E;AAC1E;EACE,aAAa;AACf;AACA,0EAA0E;AAC1E;EACE,gBAAgB;AAClB;AACA,2EAA2E;AAC3E;;EAEE,kBAAkB;AACpB;AACA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;AACA,2EAA2E;AAC3E;EACE,aAAa;AACf;AACA,2EAA2E;AAC3E;;EAEE,sBAAsB;AACxB;AACA,2EAA2E;AAC3E;EACE,aAAa;EACb,cAAc;AAChB;AACA,2EAA2E;AAC3E;;EAEE,cAAc;AAChB;AACA,2EAA2E;AAC3E;;EAEE,aAAa;AACf;AACA,2EAA2E;AAC3E;EACE,mBAAmB;AACrB;AACA,2EAA2E;AAC3E;EACE,uBAAuB;EACvB,YAAY;EACZ,MAAM;EACN,QAAQ;AACV;AACA,2EAA2E;AAC3E;EACE,eAAe;AACjB;AACA,2EAA2E;AAC3E;EACE,YAAY;AACd;AACA,2EAA2E;AAC3E;EACE,UAAU;EACV,QAAQ;AACV;AACA,2EAA2E;AAC3E;;;;EAIE,UAAU;EACV,mBAAmB;AACrB;AACA,2EAA2E;AAC3E;;EAEE,UAAU;AACZ;AACA,2EAA2E;AAC3E;;EAEE,WAAW;AACb;AACA,2EAA2E;AAC3E;EACE,kBAAkB;AACpB;AACA,2EAA2E;AAC3E,6EAA6E;AAC7E;EACE,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;AACA,2EAA2E;AAC3E;EACE,aAAa;AACf;AACA,2EAA2E;AAC3E;EACE,aAAa;AACf;AACA,2EAA2E;AAC3E;EACE,aAAa;AACf;AACA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA,2EAA2E;AAC3E;EACE,gBAAgB;AAClB;AACA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA,2EAA2E;AAC3E;;EAEE,WAAW;AACb;AACA,2EAA2E;AAC3E;EACE,iBAAiB;AACnB;AACA,2EAA2E;AAC3E;;EAEE,WAAW;AACb;AACA,2EAA2E;AAC3E;;EAEE,wBAAwB;AAC1B;AACA,2EAA2E;AAC3E;;EAEE,UAAU;AACZ;AACA,2EAA2E;AAC3E;;EAEE,uBAAuB;AACzB;AACA,2EAA2E;AAC3E;;EAEE,iBAAiB;AACnB;AACA,2EAA2E;AAC3E;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA,2EAA2E;AAC3E;EACE,eAAe;EACf,cAAc;AAChB;AACA,2EAA2E;AAC3E;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB","sourcesContent":["/* line 16, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel {\n  background-color: #f8f8f8;\n  position: relative;\n}\n/* line 20, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel:empty {\n  display: none;\n}\n/* line 24, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel label,\n.bpp-properties-panel input {\n  vertical-align: middle;\n}\n/* line 30, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel input,\n.bpp-properties-panel button,\n.bpp-properties-panel textarea {\n  padding: 3px 6px;\n  border: 1px solid #ccc;\n}\n/* line 36, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel input:focus,\n.bpp-properties-panel button:focus,\n.bpp-properties-panel textarea:focus {\n  outline: none;\n  border-color: #52B415;\n  box-shadow: 0 0 1px 2px rgba(82, 180, 21, 0.2);\n}\n/* line 40, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel input.invalid,\n.bpp-properties-panel button.invalid,\n.bpp-properties-panel textarea.invalid {\n  border-color: #cc3333;\n  background: #f0c2c2;\n}\n/* line 42, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel input.invalid:focus,\n.bpp-properties-panel button.invalid:focus,\n.bpp-properties-panel textarea.invalid:focus {\n  box-shadow: 0 0 1px 2px rgba(204, 51, 51, 0.2);\n}\n/* line 49, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel [type=text],\n.bpp-properties-panel textarea,\n.bpp-properties-panel select {\n  width: 100%;\n}\n/* line 55, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel textarea {\n  resize: vertical;\n}\n/* line 59, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel label {\n  font-weight: bolder;\n  display: inline-block;\n  vertical-align: middle;\n  color: #666;\n}\n/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel label[for] {\n  cursor: pointer;\n}\n/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel label.bpp-hidden {\n  display: none;\n}\n/* line 63, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel .entry-label {\n  font-weight: bolder;\n  display: inline-block;\n  vertical-align: middle;\n  color: #666;\n  font-size: 120%;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  transition: margin 0.218s linear;\n  font-style: italic;\n}\n/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel .entry-label[for] {\n  cursor: pointer;\n}\n/* line 74, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel .entry-label.bpp-hidden {\n  display: none;\n}\n/* line 71, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel .entry-label.divider {\n  border-top: 1px dotted #ccc;\n  padding-top: 8px;\n  margin-top: 16px;\n  width: 100%;\n}\n/* line 79, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-panel button {\n  position: absolute;\n  top: 0;\n  height: 23px;\n  width: 24px;\n  overflow: hidden;\n  cursor: pointer;\n  background-color: #f8f8f8;\n  border: 1px solid #ccc;\n}\n/* line 44, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel button > span {\n  display: none;\n}\n/* line 48, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel button:before {\n  font-family: \"bpmn-js-pp\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  text-decoration: inherit;\n  text-align: center;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: relative;\n}\n/* line 53, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel button.add:before {\n  content: '\\E803';\n}\n/* line 57, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel button.clear:before {\n  content: '\\E802';\n}\n/* line 61, node_modules\\bpmn-js-properties-panel\\styles\\_mixins.less */\n.bpp-properties-panel button:hover {\n  color: #52B415;\n}\n/* line 84, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-error-message,\n.bpp-error-message.bpp-entry-link {\n  color: #cc3333;\n}\n/* line 89, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-row {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n/* line 92, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-row:first-of-type {\n  margin-top: 0;\n}\n/* line 95, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-row:last-of-type {\n  margin-bottom: 0;\n}\n/* line 100, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-textfield,\n.bpp-textarea {\n  margin-bottom: 3px;\n}\n/* line 105, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-radios-group {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 9px 0;\n}\n/* line 110, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-radios-group .bpp-radio-wrapper {\n  margin: 6px 0;\n}\n/* line 114, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-radios-group input,\n.bpp-radios-group label {\n  vertical-align: middle;\n}\n/* line 119, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-radios-group input {\n  margin-top: 0;\n  margin-left: 0;\n}\n/* line 127, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-radios-group input,\n.bpp-checkbox input {\n  margin-left: 0;\n}\n/* line 132, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-radios-group label:after,\n.bpp-checkbox label:after {\n  display: none;\n}\n/* line 139, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-textfield input {\n  padding-right: 28px;\n}\n/* line 143, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-textfield .clear {\n  background: transparent;\n  border: none;\n  top: 0;\n  right: 0;\n}\n/* line 151, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-combo-input {\n  margin-top: 7px;\n}\n/* line 156, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-select select {\n  height: 23px;\n}\n/* line 159, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-select button.add {\n  top: -22px;\n  right: 0;\n}\n/* line 169, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-select button.add,\n.bpp-element-list button.add,\n.bpp-select button.clear,\n.bpp-element-list button.clear {\n  top: -23px;\n  border-bottom: none;\n}\n/* line 176, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-select button.add,\n.bpp-element-list button.add {\n  right: 0px;\n}\n/* line 180, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-select button.clear,\n.bpp-element-list button.clear {\n  right: 23px;\n}\n/* line 185, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-entry {\n  margin-bottom: 9px;\n}\n/* line 188, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n/* 05/10/2022 Paul.  React Client is not displaying a border for the input. */\n.bpp-properties-entry .bpp-field-wrapper {\n  position: relative;\n}\n.bpp-field-wrapper > div\n{\r\n  border: 1px solid #cccccc;\n  background-color: white;\n  padding: 5px;\n}\n/* line 191, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-entry .bpp-field-wrapper input[readonly] + .clear {\n  display: none;\n}\n/* line 197, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-hidden {\n  display: none;\n}\n/* line 201, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\nlabel.bpp-hidden {\n  display: none;\n}\n/* line 206, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-add-row > button {\n  position: relative;\n  margin-left: 10px;\n}\n/* line 212, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table {\n  margin-top: 10px;\n}\n/* line 216, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row {\n  margin-bottom: 2px;\n  overflow: hidden;\n}\n/* line 220, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > input,\n.bpp-table-row > button {\n  float: left;\n}\n/* line 225, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > label {\n  padding-left: 5px;\n}\n/* line 232, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > label.bpp-table-row-columns-1,\n.bpp-table-row > input.bpp-table-row-columns-1 {\n  width: 100%;\n}\n/* line 234, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > label.bpp-table-row-columns-1.bpp-table-row-removable,\n.bpp-table-row > input.bpp-table-row-columns-1.bpp-table-row-removable {\n  width: calc(100% - 24px);\n}\n/* line 239, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > label.bpp-table-row-columns-2,\n.bpp-table-row > input.bpp-table-row-columns-2 {\n  width: 50%;\n}\n/* line 241, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > label.bpp-table-row-columns-2.bpp-table-row-removable,\n.bpp-table-row > input.bpp-table-row-columns-2.bpp-table-row-removable {\n  width: calc(50% - 12px);\n}\n/* line 244, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > label.bpp-table-row-columns-2:nth-child(2),\n.bpp-table-row > input.bpp-table-row-columns-2:nth-child(2) {\n  border-left: none;\n}\n/* line 250, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-table-row > button {\n  border-left: none;\n  position: static;\n}\n/* line 256, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-properties-static {\n  margin-bottom: 0;\n  margin-top: 0;\n  border: 1px solid #ccc;\n  background-color: white;\n  padding: 3px 6px;\n  font: 13.3333px Arial;\n  width: 100%;\n}\n/* line 266, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-entry-link {\n  cursor: pointer;\n  color: #52B415;\n}\n/* line 271, node_modules\\bpmn-js-properties-panel\\styles\\properties.less */\n.bpp-icon-warning:before {\n  font-family: \"bpmn-js-pp\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  text-decoration: inherit;\n  text-align: center;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: '\\E806';\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
